var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriveCardIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1197_10969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1197_10969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.707031 6.44751V20.8228C0.707031 21.5732 1.31531 22.1814 2.06567 22.1814H14.3811H22.7677H26.6965C27.4469 22.1814 28.0552 21.5732 28.0552 20.8228V13.2407V6.44751C28.0552 5.69715 27.4469 5.08887 26.6965 5.08887H14.3811H4.12555H2.06567C1.31532 5.08887 0.707031 5.69715 0.707031 6.44751Z",
    fill: "url(#paint0_linear_1197_10969)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.707031,
    y1: 21.5021,
    x2: 22.7959,
    y2: 21.5021,
    stroke: "#D9D2E8",
    strokeWidth: 1.35864
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.0387 26.389L15.0387 26.7966H15.0387L15.0387 26.389ZM10.8313 25.9815C10.6062 25.9815 10.4237 26.1639 10.4237 26.389C10.4237 26.6142 10.6062 26.7966 10.8313 26.7966L10.8313 25.9815ZM19.2461 26.7966C19.4712 26.7966 19.6537 26.6142 19.6537 26.389C19.6537 26.1639 19.4712 25.9815 19.2461 25.9815L19.2461 26.7966ZM14.6311 22.1816L14.6311 26.389L15.4463 26.389L15.4463 22.1816L14.6311 22.1816ZM15.0387 25.9815L10.8313 25.9815L10.8313 26.7966L15.0387 26.7966L15.0387 25.9815ZM15.0387 26.7966L19.2461 26.7966L19.2461 25.9815L15.0387 25.9815L15.0387 26.7966Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.0059,
    y: 12.4517,
    width: 10.5185,
    height: 15.7778,
    rx: 1.57778,
    fill: "url(#paint1_linear_1197_10969)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1197_10969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.27803 10.8735C7.27803 10.8735 10.644 9.19059 10.644 6.66614V3.72096L7.27803 2.45874L3.91211 3.72096V6.66614C3.91211 9.19059 7.27803 10.8735 7.27803 10.8735Z",
    fill: "url(#paint2_linear_1197_10969)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 27.2562,
    cy: 26.4911,
    r: 0.799209,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1197_10969",
    x: 2.55347,
    y: 2.45874,
    width: 9.4497,
    height: 11.1321,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.35864
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.67932
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.386108 0 0 0 0 0.344377 0 0 0 0 0.866016 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1197_10969"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1197_10969",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1197_10969",
    x1: -0.264218,
    y1: 7.53613,
    x2: 24.6251,
    y2: 32.2593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E372FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1197_10969",
    x1: 27.2651,
    y1: 12.4517,
    x2: 27.2651,
    y2: 28.2294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1197_10969",
    x1: 7.27803,
    y1: 2.45874,
    x2: 7.27803,
    y2: 10.8735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DC0FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1197_10969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.6074,
    height: 32.6074,
    fill: "white",
    transform: "translate(0.179688 0.355225)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1197_10969"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.707031,
    y: 5.08887,
    width: 27.3481,
    height: 17.0926,
    rx: 1.35864,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveCardIcon7);
export default __webpack_public_path__ + "static/media/drive_card_icon7.a980f6aa5f7c6f6a549b3920cf79d3f1.svg";
export { ForwardRef as ReactComponent };